






























































import { computed, ComputedRef, defineComponent } from '@vue/composition-api';
import { useAllResources } from '@/store/modules/resources';
import { useAllSamplingCollections } from '@/store/modules/samplingCollections';
import { useAllSamplings } from '@/store/modules/samplings';
import { Field, LocationCollection, Sampling, SamplingCollection, SamplingCollectionStatus } from '@/store/types';
import { ORPHANED_DRAFT_SAMPLING_COLLECTION_INFO } from '../../constants';
import DownloadLabInventoryButton from './DownloadLabInventoryButton.vue';
import SamplingCollectionDelete from './SamplingCollectionDelete.vue';

export default defineComponent({
	props: {
		id: {
			type: String,
			required: true,
		},
	},
	components: {
		DownloadLabInventoryButton,
		SamplingCollectionDelete,
	},
	setup(props, { root }) {
		const editPath = `/sampling-collection/${props.id}/edit`;

		const {
			isLoaded: resourcesAreLoaded,
			isLoading: resourcesAreLoading,
			hasError: resourcesHaveError,
			samplingCollections: submittedSamplingCollections,
		} = useAllResources(root.$store);

		const {
			isLoaded: draftsAreLoaded,
			isLoading: draftsAreLoading,
			hasError: draftsHaveError,
			samplingCollections: draftSamplingCollections,
		} = useAllSamplingCollections(root.$store);

		const {
			isLoaded: samplingsAreLoaded,
			isLoading: samplingsAreLoading,
			hasError: samplingsHaveError,
		} = useAllSamplings(root.$store);

		const isLoaded = computed(() => resourcesAreLoaded.value && draftsAreLoaded.value && samplingsAreLoaded.value);

		const isLoading = computed(() =>
			[draftsAreLoading.value, samplingsAreLoading.value, resourcesAreLoading.value].some(Boolean)
		);

		const hasError = computed(() =>
			[draftsHaveError.value, samplingsHaveError.value, resourcesHaveError.value].some(Boolean)
		);

		const samplingCollectionStatus: ComputedRef<SamplingCollectionStatus> = computed(() =>
			root.$store.getters.getSamplingCollectionStatusBySamplingCollectionId(props.id)
		);

		const samplingCollection: ComputedRef<SamplingCollection | undefined> = computed(
			() =>
				submittedSamplingCollections.value?.find(({ id }: SamplingCollection) => id === props.id) ||
				draftSamplingCollections.value?.find(({ id }: SamplingCollection) => id === props.id)
		);

		const samplings: ComputedRef<Sampling[]> = computed(() => {
			if (samplingCollectionStatus.value === 'SUBMITTED') {
				return root.$store.getters['resources/getSamplingsBySamplingCollectionId'](props.id);
			} else if (samplingCollectionStatus.value === 'DRAFT') {
				return root.$store.getters['samplings/getBySamplingCollectionId'](props.id);
			}
			return [];
		});

		const locationCollection: ComputedRef<LocationCollection | undefined> = computed(() =>
			root.$store.getters['resources/getLocationCollectionById'](samplingCollection.value?.object)
		);

		const locationsCount: ComputedRef<number> = computed(() => locationCollection.value?.features?.length ?? 0);

		const progressText: ComputedRef<string> = computed(() =>
			isLoaded.value
				? locationCollection.value
					? `${samplings.value.length} / ${locationsCount.value}`
					: `${samplings.value.length}`
				: ''
		);

		const field: ComputedRef<Field | undefined> = computed(() =>
			root.$store.getters['resources/getFieldById'](samplingCollection.value?.featureOfInterest)
		);

		return {
			editPath,
			isLoaded,
			isLoading,
			hasError,
			locationCollection,
			samplingCollection,
			samplingCollectionStatus,
			field,
			progressText,
			ORPHANED_DRAFT_SAMPLING_COLLECTION_INFO,
		};
	},
});
